import { render, staticRenderFns } from "./MenuSlot.vue?vue&type=template&id=4a21f2de&shadow"
import script from "./MenuSlot.vue?vue&type=script&lang=js&shadow"
export * from "./MenuSlot.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports